import * as actionTypes from "../constants";

import type { EncounterExportState } from "../models";

const createExportEncountersState = (): EncounterExportState => ({
  busy: false,
  exportTaskId: null,
  status: "",
  error: "",
});

export const exportEncountersReducer = (state = createExportEncountersState(), action) => {
  switch (action.type) {
    case actionTypes.ENCOUNTER_EXPORT_BEGIN_WAIT:
      return {
        ...state,
        busy: true,
        error: "",
        // stats
      };

    case actionTypes.ENCOUNTER_EXPORT_SET_TASK_ID:
      return {
        ...state,
        exportTaskId: action.payload.exportTaskId,
        status: action.payload.status,
        busy: true,
      };

    case actionTypes.ENCOUNTER_EXPORT_SET_STATUS:
      return {
        ...state,
        status: action.payload.status,
        error: action.payload.error,
      };

    case actionTypes.ENCOUNTER_EXPORT_END_WAIT:
      return {
        ...state,
        busy: false,
      };

    case actionTypes.ENCOUNTER_EXPORT_CANCEL:
      return {
        ...state,
        status: "",
        error: "",
        exportTaskId: null,
        busy: false,
      };

    default:
      return state;
  }
};
